<div class="legend-section" [class.shift-right-legend]="sidebarIsOpen">
  <div class="header">{{ 'MAP.LEGENDS.HEADER.LAYER' | translate }}</div>
  <div *ngFor="let layer of layers" class="layer-field">
    <fa-icon [icon]="layer.icon" [classList]="layer.class"></fa-icon>
    <span>{{ layer.label | translate }}</span>
  </div>

  <div class="header">{{ 'MAP.LEGENDS.HEADER.TRENDS' | translate }}</div>
  <div *ngFor="let trend of trends" class="trend-field">
    <i [class]="trend.icon"></i>
    <span>{{ trend.label | translate }}</span>
  </div>
</div>

<div class="level-section" [class.shift-right-level]="sidebarIsOpen">
  <div class="header">{{ 'MAP.LEGENDS.HEADER.LEVELS' | translate }}</div>
  <div class="legend-container">
    <div class="gradient">
      <div 
        *ngFor="let level of levels" 
        class="color-segment" 
        [ngStyle]="{'background-color': level.color, 'border-left': '3px solid ' + level.color}">
      </div>
    </div>
      <div class="level-field" >
        <span *ngFor="let level of levels">{{ level.label | translate }}</span>
      </div>
  </div>
</div>

<div class="logo-section" [class.shift-right-logo]="sidebarIsOpen">
  <img class="img-depth" src="assets/images/logo.png" alt="{{ 'MAP.LEGENDS.ALT_LOGO' | translate }}" >
</div>